<template>
  <v-container style="height:100%" class="d-flex align-center align-self-center">
    <LanguageSwitch style="position: absolute;top:20px; right:20px" noUser/>

  <v-row class="align-center">
    <v-col  cols="12" md="6">
      <div class="py-15 py-md-0">
        <v-img class="mx-auto mb-5" width="200px" :src="require('@/assets/logo.png')"></v-img>

        <v-alert width="fit-content" max-width="500px" class="ma-5 mx-auto" type="warning" color="accent" density="compact" >
          {{$t('welcome')}}
        </v-alert>
        <router-view/>
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <v-img cover height="100%" :src="require('@/assets/brandon-griggs-wR11KBaB86U-unsplash.jpg')" style="width:100%;height:100%" alt=""/>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch.vue";

export default {
  data(){
    return{
      secret:"",
    }
  },
  methods:{
  },
  name: "LoginWrapper",
  components: {LanguageSwitch}
}
</script>

<style scoped>

</style>